export { default as useLegalDocuments } from './useLegalDocuments';
